import { useState } from "react";
import { Switch } from "../ui/switch";
import { LAUNCHERS } from "../../lib/api";

const input = "mt-1.5 h-11 w-full border border-white/15 bg-black/40 px-3 text-sm text-white focus:border-[#a259ff] focus:outline-none";
const lbl = "block font-mono text-[11px] uppercase tracking-widest text-slate-400";

export const ProductForm = ({ initial, onSave }) => {
  const [f, setF] = useState({
    name: initial.name ?? "", tagline: initial.tagline ?? "", platform: initial.platform ?? "pc",
    price: initial.price ?? "", money: initial.money ?? "", rank: initial.rank ?? 0, stock: initial.stock ?? 1,
    image: initial.image ?? "", unlocks: (initial.unlocks ?? []).join(", "), featured: initial.featured ?? false,
    launcher: initial.launcher ?? "",
  });
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    onSave({ ...f, price: Number(f.price), rank: Number(f.rank), stock: Number(f.stock), launcher: f.launcher || null,
      unlocks: f.unlocks.split(",").map((s) => s.trim()).filter(Boolean) });
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="admin-product-form">
      <label className={lbl}>Name<input required value={f.name} onChange={set("name")} className={input} data-testid="product-name-input" /></label>
      <label className={lbl}>Tagline<input value={f.tagline} onChange={set("tagline")} className={input} data-testid="product-tagline-input" /></label>
      <div className="grid grid-cols-2 gap-3">
        <label className={lbl}>PC launcher
          <select value={f.launcher} onChange={set("launcher")} className={input} data-testid="product-launcher-select">
            <option value="">Not set</option>
            {Object.entries(LAUNCHERS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </label>
        <label className={lbl}>Price (USD)<input required type="number" min="0.5" step="0.01" value={f.price} onChange={set("price")} className={input} data-testid="product-price-input" /></label>
        <label className={lbl}>Bank money<input value={f.money} onChange={set("money")} placeholder="$2B" className={input} data-testid="product-money-input" /></label>
        <label className={lbl}>Rank<input type="number" min="0" value={f.rank} onChange={set("rank")} className={input} data-testid="product-rank-input" /></label>
        <label className={lbl}>Stock<input type="number" min="0" value={f.stock} onChange={set("stock")} className={input} data-testid="product-stock-input" /></label>
        <label className="flex items-end gap-3 pb-2 font-mono text-[11px] uppercase tracking-widest text-slate-400">
          <Switch checked={f.featured} onCheckedChange={(v) => setF((s) => ({ ...s, featured: v }))} data-testid="product-featured-switch" /> Featured
        </label>
      </div>
      <label className={lbl}>Image URL<input value={f.image} onChange={set("image")} placeholder="https://…" className={input} data-testid="product-image-input" /></label>
      <label className={lbl}>Unlocks (comma separated)<textarea value={f.unlocks} onChange={set("unlocks")} rows={3} className={`${input} h-auto py-2`} data-testid="product-unlocks-input" /></label>
      <button className="h-12 w-full bg-[#ff3dc8] font-mono text-xs font-bold uppercase tracking-widest text-white" data-testid="product-save-button">Save account</button>
    </form>
  );
};
